export default function generate(Service, operation) {
  let key = `mass${operation.charAt(0).toUpperCase() + operation.slice(1)}`;
  const actions = {};
  actions[key] = function(
    store,
    { ids, destination_id, onSuccess = () => {}, onError = () => {} }
  ) {
    return Service[operation]({ ids, destination_id }, onSuccess, onError);
  };
  return {
    actions
  };
}
